import { useContext } from "react";
import { CsValueContext } from "../context/CsValueContext";
/**
 * Get a value
 * - requires {@linkcode CsValueController}
 * @category Hook
 * @category CsValue
 * @export
 * @template TValue
 * @returns {TValue}
 */
export function useCsValue() {
    const csValue = useContext(CsValueContext);
    return csValue;
}
//# sourceMappingURL=useCsValue.js.map